<container kind="mini">
  <page-intro-header title="{{ 'HOME.NOTIFICATIONS' | translate }}">
  </page-intro-header>
  <mat-card class="paginator-wrapper">
    <mat-grid-list cols="5" style="width: 100%;margin-bottom: 10px" class="footer-grid">
      <button mat-icon-button [ngStyle]="{ width: isServiceProviderUser ? '20%' : '16%', height: '100%'}" color="primary" (click)="findByGroup('ALL')"
        matTooltip="{{ 'SECONDARY_NAVIGATION.ALL_NOTIFICATIONS' | translate }}">
        <mat-icon class="button-square__icon">format_list_bulleted</mat-icon>
      </button>
      <button mat-icon-button [ngStyle]="{ width: isServiceProviderUser ? '20%' : '16%', height: '100%'}" color="primary" (click)="findByGroup('SUPERVISION')"
        matTooltip="{{ 'SECONDARY_NAVIGATION.ALL_SUPERVISION' | translate }}">
        <mat-icon class="button-square__icon">supervisor_account</mat-icon>
      </button>
      <button mat-icon-button [ngStyle]="{ width: isServiceProviderUser ? '20%' : '16%', height: '100%'}" color="primary" (click)="findByGroup('SYSTEM')"
        matTooltip="{{ 'SECONDARY_NAVIGATION.ALL_SYSTEM' | translate }}">
        <mat-icon class="button-square__icon">settings_system_daydream</mat-icon>
      </button>
      <button mat-icon-button style="width: 16%; height: 100%;" color="primary" (click)="findByGroup('PISARNICA')" *ngIf="!isServiceProviderUser"
        matTooltip="{{ 'SECONDARY_NAVIGATION.ALL_PISARNICA' | translate }}">
        <mat-icon class="button-square__icon">tv</mat-icon>
      </button>
      <button mat-icon-button [ngStyle]="{ width: isServiceProviderUser ? '20%' : '16%', height: '100%'}" color="primary" (click)="findByGroup('USERS')"
        matTooltip="{{ 'SECONDARY_NAVIGATION.ALL_USERS' | translate }}">
        <mat-icon class="button-square__icon">contacts</mat-icon>
      </button>
       <button mat-icon-button [ngStyle]="{ width: isServiceProviderUser ? '20%' : '16%', height: '100%'}" (click)="findByGroup('CONTROL_DATE')"
        matTooltip="{{ 'SECONDARY_NAVIGATION.CONTROL_DATE' | translate }}">
        <mat-icon class="button-square__icon">calendar_today</mat-icon>
      </button>
    </mat-grid-list>
  </mat-card>

  <mat-card class="card">
    <no-result-item *ngIf="notifications.length === 0">
      {{ 'HOME.CARDS.NOTIFICATIONS.NO_NOTIFICATIONS' | translate }}</no-result-item>
    <mat-list>
      <mat-list-item *ngFor="let notification of notifications; last as last">
        <h4 mat-line>
          <mat-label>
            <b>{{ notification.fromWho }}</b></mat-label>
        </h4>
        <h2 mat-line>{{ notification.message }}</h2>
        <span class="date">{{ notification.date | date: 'dd.MM.yyyy. HH:mm:ss' }}</span>
        <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
      </mat-list-item>
    </mat-list>
  </mat-card>
  <mat-card class="paginator-footer">
    <app-custom-pagination [page]="page" (firstPageEvent)="getFirstPage()" (previousPageEvent)="getPreviousPage()"
      (nextPageEvent)="getNextPage()" (lastPageEvent)="getLastPage()" (pageSizeEvent)="getPageInNewSize($event)">
    </app-custom-pagination>
  </mat-card>
</container>